import {
  DetailedHTMLProps,
  ForwardedRef,
  forwardRef,
  TextareaHTMLAttributes,
} from 'react'
import cx from 'classnames'

type TextareaProps = {
  label: string
  id?: string
  name?: string
  placeholder?: string
  value?: string
  register?: any
  error?: string
  rows?: number
} & DetailedHTMLProps<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
>

const Textarea = forwardRef(
  (
    {
      label,
      id,
      name,
      register,
      error,
      placeholder,
      rows = 4,
      ...rest
    }: TextareaProps,
    ref: ForwardedRef<HTMLTextAreaElement>,
  ) => {
    return (
      <div className="formControl">
        <label className="formControl-label" htmlFor={id}>
          {label}
        </label>
        <textarea
          ref={ref}
          className={cx('formControl-input', error && 'error')}
          id={id}
          name={name}
          placeholder={placeholder}
          rows={rows}
          {...(register && name ? register(name) : {})}
          {...rest}
        />
        {error && <span className="formControl-error">{error}</span>}
      </div>
    )
  },
)

export default Textarea
